import * as signalR from "@microsoft/signalr";

let connection: any = null;

export const startConnection = async (
  onMessageReceived: (message: any) => void,
  onSyncCompleted: () => void,
  onUpdateWorkingHourCompleted: () => void,
  onKnowledgeBaseProcessingCompleted: (datasetId: any) => void,
  onDirectMessageReceived: (message: any) => void,
) => {
  connection = new signalR.HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_API_URL}/signalr-hubs/Notification`, {
      // Authenticate the hub so the server can target messages to a specific user.
      accessTokenFactory: () => localStorage.getItem("authUser") || "",
    })
    .withAutomaticReconnect()
    .build();

  // Listener cho ReceiveMessage
  connection.on("ReceiveMessage", async (message: any) => {
    console.log("API called -> New message received");
    await onMessageReceived(message);
  });

  // Internal 1:1 direct message
  connection.on("ReceiveDirectMessage", async (message: any) => {
    console.log("New direct message received");
    await onDirectMessageReceived(message);
  });

  connection.on("SyncCompleted", async () => {
    localStorage.removeItem("isSyncing");
    console.log("Sync completed event received");
    await onSyncCompleted();
  });

  connection.on("UpdatedWorkingHourSuccessfully", async () => {
    console.log("Working hour settings updated successfully");
    await onUpdateWorkingHourCompleted();
  });

  connection.on("KnowledgeBaseProcessingCompleted", async (datasetId: any) => {
    console.log(
      "Knowledge base processing completed for dataset ID:",
      datasetId,
    );
    await onKnowledgeBaseProcessingCompleted(datasetId);
  });

  try {
    await connection.start();
    console.log("SignalR Connected.");
  } catch (err) {
    console.error("SignalR Connection Error: ", err);
  }
};

export const stopConnection = async () => {
  if (connection) {
    await connection.stop();
    connection = null;
  }
};
